// API utility file for centralized axios configuration
// Uses environment variable for backend URL
import axios from 'axios';

// Get the API base URL from environment variables
// React requires environment variables to start with REACT_APP_
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Create an axios instance with default configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor (for adding auth tokens, etc.)
api.interceptors.request.use(
  (config) => {
    // Add admin authentication token if available
    const token = sessionStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor (for handling errors globally)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401) {
      // Clear invalid token from sessionStorage
      sessionStorage.removeItem('adminToken');
      sessionStorage.removeItem('adminAuthenticated');
    }
    return Promise.reject(error);
  }
);

export default api;

